/**
 * This is a place for map configuration instance context.
 * It should provide necessary reusable getters, setters and any logic for controlling OpenLayers map state.
 */

import Vue from 'vue';

export function getContext(self) {
  return self.mapContext ? self.mapContext : self.$root;
}

export function getMapContextInstance() {
  return new Vue({
    name: 'mapInstanceContext',
  });
}
